import React, { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { getStoredUser } from "../lib/auth";
import { useLanguage } from "../lib/language";
import { repairMojibakeDeep } from "../lib/text";

// مساحة الطالب: دخول التقييم، التسليم، ومراجعة التاريخ والنتائج والتقرير الشخصي.
function StudentExam() {
  const user = getStoredUser();
  const { language } = useLanguage();
  const isArabic = language === "ar";

  const rawCopy = isArabic
    ? {
        enterCodePrompt: "من فضلك أدخل كود التقييم",
        codeNotFound: "تعذر العثور على هذا الكود",
        noQuestions: "هذا التقييم لا يحتوي على أسئلة متاحة الآن",
        loadQuestionsError: "تعذر تحميل الأسئلة",
        loginAgain: "سجل الدخول مرة أخرى ثم حاول من جديد",
        answerAll: "من فضلك أجب عن كل الأسئلة قبل التسليم",
        submitSuccess: "تم تسليم التقييم بنجاح. درجتك الحالية:",
        submitError: "حدث خطأ أثناء التسليم",
        resultUnavailable: "لا يمكن عرض تفاصيل هذه النتيجة الآن",
        workspaceEyebrow: "مساحة الطالب",
        workspaceTitle: "بوابة الطالب",
        examTab: "حل التقييم",
        historyTab: "سجلي ونتائجي",
        entryEyebrow: "دخول التقييم",
        entryTitle: "ابدأ التقييم",
        enterBaseCode: "أدخل الكود الأساسي للتقييم",
        codeHelp: "بعد إدخال الكود سنعرض لك إذا كنت تريد حل النسخة القبلية أو البعدية.",
        codePlaceholder: "اكتب الكود هنا",
        continue: "متابعة",
        loading: "جار التحميل...",
        chooseAttempt: "اختر نوع المحاولة",
        preAssessment: "التقييم القبلي",
        postAssessment: "التقييم البعدي",
        alreadySolved: "تم حل هذه النسخة من قبل",
        canStart: "يمكنك بدء هذه النسخة الآن",
        start: "ابدأ",
        preLabel: "قبلي",
        postLabel: "بعدي",
        essayPlaceholder: "اكتب إجابتك هنا",
        submitting: "جارٍ التسليم...",
        submit: "تسليم التقييم",
        historyEyebrow: "سجل الطالب",
        historyTitle: "التقييمات السابقة",
        noHistory: "لا توجد نتائج متاحة لك حاليًا أو أن المدرب لم يسمح بعرضها بعد.",
        dashboardTitle: "ملخص تقدمي",
        totalAttempts: "إجمالي المحاولات",
        completedComparisons: "مقارنات مكتملة",
        latestScore: "آخر درجة",
        bestScore: "أفضل درجة",
        trackedCourses: "كورسات نشطة",
        comparisonTitle: "مقارنة القبلي والبعدي",
        noComparison: "لا توجد مقارنة مكتملة بين القبلي والبعدي لهذا الكورس حتى الآن.",
        improvement: "التحسن",
        score: "الدرجة",
        resultEyebrow: "تفاصيل النتيجة",
        resultTitle: "تفاصيل النتيجة",
        chooseResult: "اختر نتيجة من القائمة لعرض التفاصيل والتقرير الخاص بك.",
        course: "الكورس",
        yourReport: "تقريرك",
        previousAnswers: "إجاباتك السابقة",
        noEssayAnswer: "لا توجد إجابة نصية",
        noSelectedOption: "لا يوجد اختيار",
        sentiment: "المشاعر",
        level: "المستوى",
        pleaseLogin: "سجل الدخول أولًا لعرض بياناتك.",
        searchLabel: "بحث داخل النتائج",
        searchPlaceholder: "ابحث باسم الكورس أو عنوان التقييم",
        attemptFilter: "نوع المحاولة",
        allAttempts: "كل المحاولات",
        courseFilter: "فلتر الكورس",
        allCourses: "كل الكورسات",
        submittedAt: "تاريخ التسليم",
        attemptType: "نوع المحاولة",
        reportUnavailable: "لا يوجد تقرير متاح لهذه النتيجة",
        noSearchResults: "لا توجد نتائج مطابقة للفلاتر الحالية.",
        historyLoading: "جار تحميل النتائج...",
        detailsLoading: "جار تحميل تفاصيل النتيجة...",
        averageScore: "متوسط الدرجات",
        preAttempts: "محاولات قبلية",
        postAttempts: "محاولات بعدية",
        sortLabel: "ترتيب النتائج",
        sortLatest: "الأحدث أولًا",
        sortHighest: "الأعلى درجة",
        hiddenAnswers: "المدرب لم يُتح عرض الإجابات لهذه النتيجة بعد.",
        hiddenReport: "المدرب لم يُتح عرض تقرير الذكاء الاصطناعي لهذه النتيجة بعد."
      }
    : {
        enterCodePrompt: "Please enter the assessment code",
        codeNotFound: "Could not find this code",
        noQuestions: "This assessment has no available questions right now",
        loadQuestionsError: "Could not load questions",
        loginAgain: "Please log in again and try one more time",
        answerAll: "Please answer all questions before submitting",
        submitSuccess: "Assessment submitted successfully. Your current score is:",
        submitError: "An error happened while submitting",
        resultUnavailable: "This result cannot be shown right now",
        workspaceEyebrow: "Student Workspace",
        workspaceTitle: "Student Portal",
        examTab: "Take Assessment",
        historyTab: "My History & Results",
        entryEyebrow: "Assessment Entry",
        entryTitle: "Start Assessment",
        enterBaseCode: "Enter the assessment base code",
        codeHelp: "After entering the code, we will show whether you want the pre or post version.",
        codePlaceholder: "Type the code here",
        continue: "Continue",
        loading: "Loading...",
        chooseAttempt: "Choose the attempt type",
        preAssessment: "Pre Assessment",
        postAssessment: "Post Assessment",
        alreadySolved: "This version has already been completed",
        canStart: "You can start this version now",
        start: "Start",
        preLabel: "Pre",
        postLabel: "Post",
        essayPlaceholder: "Write your answer here",
        submitting: "Submitting...",
        submit: "Submit Assessment",
        historyEyebrow: "Student History",
        historyTitle: "Previous Assessments",
        noHistory: "No results are available right now, or the trainer did not allow them yet.",
        dashboardTitle: "Progress Snapshot",
        totalAttempts: "Total Attempts",
        completedComparisons: "Completed Comparisons",
        latestScore: "Latest Score",
        bestScore: "Best Score",
        trackedCourses: "Active Courses",
        comparisonTitle: "Pre / Post Comparison",
        noComparison: "There is no complete pre/post comparison for this course yet.",
        improvement: "Improvement",
        score: "Score",
        resultEyebrow: "Result Details",
        resultTitle: "Result Details",
        chooseResult: "Choose a result from the list to view details and your report.",
        course: "Course",
        yourReport: "Your Report",
        previousAnswers: "Your Previous Answers",
        noEssayAnswer: "No written answer",
        noSelectedOption: "No selected option",
        sentiment: "Sentiment",
        level: "Level",
        pleaseLogin: "Please log in first to view your data.",
        searchLabel: "Search Results",
        searchPlaceholder: "Search by course or assessment title",
        attemptFilter: "Attempt Type",
        allAttempts: "All Attempts",
        courseFilter: "Course Filter",
        allCourses: "All Courses",
        submittedAt: "Submitted At",
        attemptType: "Attempt Type",
        reportUnavailable: "No report is available for this result",
        noSearchResults: "No results match the current filters.",
        historyLoading: "Loading results...",
        detailsLoading: "Loading result details...",
        averageScore: "Average Score",
        preAttempts: "Pre Attempts",
        postAttempts: "Post Attempts",
        sortLabel: "Sort Results",
        sortLatest: "Latest First",
        sortHighest: "Highest Score",
        hiddenAnswers: "The trainer has not enabled answer review for this result yet.",
        hiddenReport: "The trainer has not enabled the AI report for this result yet."
      };
  const copy = repairMojibakeDeep(rawCopy);

  const [activeTab, setActiveTab] = useState("exam");
  const [sharedCode, setSharedCode] = useState("");
  const [selectedAccessCode, setSelectedAccessCode] = useState("");
  const [assessmentChoices, setAssessmentChoices] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [assessment, setAssessment] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [history, setHistory] = useState([]);
  const [historyDetails, setHistoryDetails] = useState(null);
  const [comparisonByCourse, setComparisonByCourse] = useState({});
  const [historySearch, setHistorySearch] = useState("");
  const [attemptFilter, setAttemptFilter] = useState("all");
  const [courseFilter, setCourseFilter] = useState("all");
  const [historySort, setHistorySort] = useState("latest");
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [feedbackType, setFeedbackType] = useState("info");

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!feedback) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setFeedback("");
    }, 3200);

    return () => window.clearTimeout(timeoutId);
  }, [feedback]);

  const fetchHistory = async () => {
    if (!user?.id) {
      return;
    }

    try {
      setIsLoadingHistory(true);
      const response = await api.get(`/student/${user.id}/history`);
      const nextHistory = response.data.history || [];
      setHistory(nextHistory);
      await fetchComparisons(nextHistory);
      if (nextHistory.length && !historyDetails) {
        await fetchHistoryDetails(nextHistory[0].id, { silentFeedback: true });
      }
    } catch (error) {
      setHistory([]);
      setComparisonByCourse({});
    } finally {
      setIsLoadingHistory(false);
    }
  };

  const fetchComparisons = async (historyItems) => {
    const uniqueCourses = [...new Set(historyItems.map((item) => item.course_id).filter(Boolean))];

    if (!uniqueCourses.length) {
      setComparisonByCourse({});
      return;
    }

    const results = await Promise.all(
      uniqueCourses.map(async (courseId) => {
        try {
          const response = await api.get(`/compare_results/${user.id}/${courseId}`);
          return [courseId, response.data];
        } catch (error) {
          return [courseId, null];
        }
      })
    );

    setComparisonByCourse(Object.fromEntries(results));
  };

  const resolveAssessmentCode = async () => {
    if (!sharedCode.trim()) {
      setFeedbackType("error");
      setFeedback(copy.enterCodePrompt);
      return;
    }

    try {
      setIsLoadingQuestions(true);
      const response = await api.get(`/resolve_assessment/${sharedCode.trim()}`, {
        params: { student_id: user?.id }
      });
      setAssessmentChoices(response.data.assessments || []);
      setFeedbackType("info");
      setFeedback("");
    } catch (error) {
      setAssessmentChoices([]);
      setFeedbackType("error");
      setFeedback(error.response?.data?.error || copy.codeNotFound);
    } finally {
      setIsLoadingQuestions(false);
    }
  };

  const startAttempt = async (choice) => {
    try {
      setIsLoadingQuestions(true);
      const response = await api.get(`/get_questions/${choice.access_code}`);
      const loadedQuestions = response.data.questions || [];

      if (!loadedQuestions.length) {
        setFeedbackType("error");
        setFeedback(copy.noQuestions);
        return;
      }

      setAssessment(response.data.assessment);
      setSelectedAccessCode(choice.access_code);
      setQuestions(loadedQuestions);
      setAnswers(
        loadedQuestions.map((question) => ({
          question_id: question.id,
          answer_text: "",
          selected_option_id: null
        }))
      );
      setFeedbackType("info");
      setFeedback("");
    } catch (error) {
      setFeedbackType("error");
      setFeedback(error.response?.data?.error || copy.loadQuestionsError);
    } finally {
      setIsLoadingQuestions(false);
    }
  };

  const handleAnswerChange = (index, field, value) => {
    const updated = [...answers];
    updated[index][field] = value;
    setAnswers(updated);
  };

  const submitExam = async () => {
    if (!user?.id || !selectedAccessCode) {
      setFeedbackType("error");
      setFeedback(copy.loginAgain);
      return;
    }

    const hasInvalidAnswer = questions.some((question, index) => {
      const answer = answers[index];
      if (!answer) {
        return true;
      }

      if (question.question_type === "essay") {
        return !answer.answer_text.trim();
      }

      return answer.selected_option_id === null;
    });

    if (hasInvalidAnswer) {
      setFeedbackType("error");
      setFeedback(copy.answerAll);
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await api.post("/submit_assessment", {
        student_id: user.id,
        access_code: selectedAccessCode,
        answers
      });

      setFeedbackType("success");
      setFeedback(`${copy.submitSuccess} ${response.data.score}`);
      setQuestions([]);
      setAssessment(null);
      setSelectedAccessCode("");
      setAnswers([]);
      setAssessmentChoices([]);
      setSharedCode("");
      await fetchHistory();
      setActiveTab("history");
    } catch (error) {
      setFeedbackType("error");
      setFeedback(error.response?.data?.error || copy.submitError);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchHistoryDetails = async (submissionId, options = {}) => {
    try {
      setIsLoadingDetails(true);
      const response = await api.get(`/student/submissions/${submissionId}`, {
        params: { student_id: user?.id }
      });
      setHistoryDetails(response.data);
      if (!options.silentFeedback) {
        setFeedbackType("info");
        setFeedback("");
      }
    } catch (error) {
      setHistoryDetails(null);
      setFeedbackType("error");
      setFeedback(error.response?.data?.error || copy.resultUnavailable);
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const availableCourses = useMemo(() => {
    const map = new Map();
    history.forEach((item) => {
      if (item.course_id && item.course_title && !map.has(item.course_id)) {
        map.set(item.course_id, item.course_title);
      }
    });
    return Array.from(map.entries()).map(([id, title]) => ({ id, title }));
  }, [history]);

  const filteredHistory = useMemo(() => {
    const normalizedSearch = historySearch.trim().toLowerCase();

    const filtered = history.filter((item) => {
      const matchesSearch =
        !normalizedSearch ||
        [item.course_title, item.title, item.type]
          .filter(Boolean)
          .some((value) => String(value).toLowerCase().includes(normalizedSearch));

      const matchesAttempt = attemptFilter === "all" || item.type === attemptFilter;
      const matchesCourse = courseFilter === "all" || String(item.course_id) === courseFilter;

      return matchesSearch && matchesAttempt && matchesCourse;
    });
    if (historySort === "highest") {
      return filtered.sort((left, right) => {
        const scoreDelta = Number(right.score || 0) - Number(left.score || 0);
        if (scoreDelta !== 0) {
          return scoreDelta;
        }

        return new Date(right.submitted_at || 0) - new Date(left.submitted_at || 0);
      });
    }

    return filtered.sort(
      (left, right) => new Date(right.submitted_at || 0) - new Date(left.submitted_at || 0)
    );
  }, [history, historySearch, attemptFilter, courseFilter, historySort]);

  const latestScore = history.length ? history[0].score : "-";
  const bestScore = history.length ? Math.max(...history.map((item) => Number(item.score) || 0)) : "-";
  const averageScore = history.length
    ? (history.reduce((sum, item) => sum + (Number(item.score) || 0), 0) / history.length).toFixed(1)
    : "-";
  const preAttempts = history.filter((item) => item.type === "pre").length;
  const postAttempts = history.filter((item) => item.type === "post").length;
  const completedComparisons = Object.values(comparisonByCourse).filter(Boolean).length;
  const selectedComparison =
    historyDetails?.submission?.course_id ? comparisonByCourse[historyDetails.submission.course_id] : null;

  if (!user?.id) {
    return (
      <div className="panel">
        <div className="empty-panel state-panel state-panel--error">
          <p>{copy.pleaseLogin}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="workspace-page student-page">
      {feedback && <div className={`feedback-banner feedback-banner--${feedbackType}`}>{feedback}</div>}

      <section className="panel subnav-panel student-shell-hero">
        <div className="section-header">
          <div>
            <p className="eyebrow">{copy.workspaceEyebrow}</p>
            <h2 className="section-title">{copy.workspaceTitle}</h2>
          </div>
        </div>

        <div className="tab-row">
          <button
            className={activeTab === "exam" ? "tab-button tab-button--active" : "tab-button"}
            onClick={() => setActiveTab("exam")}
            type="button"
          >
            {copy.examTab}
          </button>
          <button
            className={activeTab === "history" ? "tab-button tab-button--active" : "tab-button"}
            onClick={() => setActiveTab("history")}
            type="button"
          >
            {copy.historyTab}
          </button>
        </div>
      </section>

      {activeTab === "exam" && (
        <section className="panel student-panel">
          <div className="section-header">
            <div>
              <p className="eyebrow">{copy.entryEyebrow}</p>
              <h2 className="section-title">{copy.entryTitle}</h2>
            </div>
          </div>

          {!questions.length && (
            <div className="stack-lg">
              <div className="empty-panel state-panel state-panel--empty">
                <h3>{copy.enterBaseCode}</h3>
                <p>{copy.codeHelp}</p>
                <div className="inline-form">
                  <input
                    placeholder={copy.codePlaceholder}
                    value={sharedCode}
                    onChange={(event) => setSharedCode(event.target.value)}
                    className="text-input"
                  />
                  <button
                    onClick={resolveAssessmentCode}
                    disabled={isLoadingQuestions}
                    className="primary-button"
                    type="button"
                  >
                    {isLoadingQuestions ? copy.loading : copy.continue}
                  </button>
                </div>
              </div>

              {!!assessmentChoices.length && (
                <div className="dashboard-card student-dashboard-card">
                  <h3>{copy.chooseAttempt}</h3>
                  <div className="entity-list">
                    {assessmentChoices.map((choice) => (
                      <div key={choice.id} className="entity-card student-attempt-card">
                        <div className="entity-main entity-main--static">
                          <strong>
                            {choice.type === "pre" ? copy.preAssessment : copy.postAssessment}
                          </strong>
                          <span>{choice.already_submitted ? copy.alreadySolved : copy.canStart}</span>
                        </div>
                        <div className="entity-actions">
                          <button
                            className="primary-button"
                            disabled={choice.already_submitted}
                            onClick={() => startAttempt(choice)}
                            type="button"
                          >
                            {copy.start}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {questions.length > 0 && (
            <div className="stack-lg">
              <div className="assessment-header">
                <h3>{assessment?.title}</h3>
                <span className="status-pill">
                  {assessment?.type === "pre" ? copy.preLabel : copy.postLabel}
                </span>
              </div>

              {questions.map((question, index) => (
                <div key={question.id} className="question-card">
                  <h4 className="question-title">
                    {index + 1}. {question.question_text}
                  </h4>

                  {question.question_type === "essay" && (
                    <textarea
                      className="text-area"
                      placeholder={copy.essayPlaceholder}
                      value={answers[index]?.answer_text || ""}
                      onChange={(event) => handleAnswerChange(index, "answer_text", event.target.value)}
                    />
                  )}

                  {(question.question_type === "mcq" ||
                    question.question_type === "true_false" ||
                    question.question_type === "rating") &&
                    question.options?.map((option) => (
                      <label key={option.id} className="option-row">
                        <input
                          type="radio"
                          name={`q-${question.id}`}
                          checked={answers[index]?.selected_option_id === option.id}
                          onChange={() => handleAnswerChange(index, "selected_option_id", option.id)}
                        />
                        {option.option_text}
                      </label>
                    ))}
                </div>
              ))}

              <button onClick={submitExam} disabled={isSubmitting} className="primary-button" type="button">
                {isSubmitting ? copy.submitting : copy.submit}
              </button>
            </div>
          )}
        </section>
      )}

      {activeTab === "history" && (
        <section className="dashboard-grid dashboard-grid--results student-history-layout">
          <div className="panel student-panel">
            <div className="section-header">
              <div>
                <p className="eyebrow">{copy.historyEyebrow}</p>
                <h2 className="section-title">{copy.historyTitle}</h2>
              </div>
            </div>

            <div className="dashboard-card student-dashboard-card">
              <div className="card-title-row">
                <h3>{copy.dashboardTitle}</h3>
              </div>
              <div className="details-grid student-stats-grid">
                <div className="detail-chip">
                  <span>{copy.totalAttempts}</span>
                  <strong>{history.length}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.completedComparisons}</span>
                  <strong>{completedComparisons}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.latestScore}</span>
                  <strong>{latestScore}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.bestScore}</span>
                  <strong>{bestScore}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.averageScore}</span>
                  <strong>{averageScore}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.trackedCourses}</span>
                  <strong>{availableCourses.length}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.preAttempts}</span>
                  <strong>{preAttempts}</strong>
                </div>
                <div className="detail-chip">
                  <span>{copy.postAttempts}</span>
                  <strong>{postAttempts}</strong>
                </div>
              </div>
            </div>

            <div className="dashboard-card student-dashboard-card">
              <div className="field-stack">
                <label className="field-label">{copy.searchLabel}</label>
                <input
                  className="text-input"
                  placeholder={copy.searchPlaceholder}
                  value={historySearch}
                  onChange={(event) => setHistorySearch(event.target.value)}
                />
              </div>

              <div className="field-grid">
                <div className="field-stack">
                  <label className="field-label">{copy.attemptFilter}</label>
                  <select
                    className="text-input"
                    value={attemptFilter}
                    onChange={(event) => setAttemptFilter(event.target.value)}
                  >
                    <option value="all">{copy.allAttempts}</option>
                    <option value="pre">{copy.preLabel}</option>
                    <option value="post">{copy.postLabel}</option>
                  </select>
                </div>

                <div className="field-stack">
                  <label className="field-label">{copy.courseFilter}</label>
                  <select
                    className="text-input"
                    value={courseFilter}
                    onChange={(event) => setCourseFilter(event.target.value)}
                  >
                    <option value="all">{copy.allCourses}</option>
                    {availableCourses.map((course) => (
                      <option key={course.id} value={String(course.id)}>
                        {course.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="field-stack">
                  <label className="field-label">{copy.sortLabel}</label>
                  <select
                    className="text-input"
                    value={historySort}
                    onChange={(event) => setHistorySort(event.target.value)}
                  >
                    <option value="latest">{copy.sortLatest}</option>
                    <option value="highest">{copy.sortHighest}</option>
                  </select>
                </div>
              </div>
            </div>

            {isLoadingHistory && (
              <div className="empty-panel state-panel state-panel--loading">
                <p>{copy.historyLoading}</p>
              </div>
            )}

            {!isLoadingHistory && !history.length && (
              <div className="empty-panel state-panel state-panel--empty">
                <p>{copy.noHistory}</p>
              </div>
            )}

            {!isLoadingHistory && !!history.length && !filteredHistory.length && (
              <div className="empty-panel state-panel state-panel--empty">
                <p>{copy.noSearchResults}</p>
              </div>
            )}

            <div className="entity-list student-results-list">
              {filteredHistory.map((item) => (
                <div key={item.id} className="entity-card student-result-item">
                  <button className="entity-main student-result-button" onClick={() => fetchHistoryDetails(item.id)} type="button">
                    <strong>{item.course_title}</strong>
                    <span>
                      {item.title} - {item.type === "pre" ? copy.preLabel : copy.postLabel}
                    </span>
                    <span>
                      {copy.score}: {item.score}
                    </span>
                    {comparisonByCourse[item.course_id] && (
                      <span>
                        {copy.preLabel}: {comparisonByCourse[item.course_id].pre_score} - {copy.postLabel}:{" "}
                        {comparisonByCourse[item.course_id].post_score} - {copy.improvement}:{" "}
                        {comparisonByCourse[item.course_id].improvement}
                      </span>
                    )}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="panel student-panel">
            <div className="section-header">
              <div>
                <p className="eyebrow">{copy.resultEyebrow}</p>
                <h2 className="section-title">{copy.resultTitle}</h2>
              </div>
            </div>

            {!historyDetails && !isLoadingDetails && (
              <div className="empty-panel state-panel state-panel--empty">
                <p>{copy.chooseResult}</p>
              </div>
            )}

            {isLoadingDetails && (
              <div className="empty-panel state-panel state-panel--loading">
                <p>{copy.detailsLoading}</p>
              </div>
            )}

            {historyDetails && !isLoadingDetails && (
              <div className="stack-lg">
                <div className="dashboard-card student-dashboard-card">
                  <div className="details-grid student-stats-grid">
                    <div className="detail-chip">
                      <span>{copy.course}</span>
                      <strong>{historyDetails.submission.course_title}</strong>
                    </div>
                    <div className="detail-chip">
                      <span>{copy.score}</span>
                      <strong>{historyDetails.submission.score}</strong>
                    </div>
                    <div className="detail-chip">
                      <span>{copy.attemptType}</span>
                      <strong>
                        {historyDetails.submission.type === "pre" ? copy.preLabel : copy.postLabel}
                      </strong>
                    </div>
                    <div className="detail-chip">
                      <span>{copy.submittedAt}</span>
                      <strong>{historyDetails.submission.submitted_at || "-"}</strong>
                    </div>
                  </div>
                </div>

                <div className="dashboard-card student-dashboard-card">
                  <h3>{copy.comparisonTitle}</h3>
                  {selectedComparison ? (
                    <div className="details-grid student-stats-grid">
                      <div className="detail-chip">
                        <span>{copy.preLabel}</span>
                        <strong>{selectedComparison.pre_score}</strong>
                      </div>
                      <div className="detail-chip">
                        <span>{copy.postLabel}</span>
                        <strong>{selectedComparison.post_score}</strong>
                      </div>
                      <div className="detail-chip">
                        <span>{copy.improvement}</span>
                        <strong>{selectedComparison.improvement}</strong>
                      </div>
                    </div>
                  ) : (
                    <div className="empty-panel compact-panel state-panel state-panel--empty">
                      <p>{copy.noComparison}</p>
                    </div>
                  )}
                </div>

                <div className="dashboard-card student-dashboard-card">
                  <div className="report-box">
                    <h4>{copy.yourReport}</h4>
                    <p>
                      {historyDetails.student_report ||
                        (historyDetails.submission?.show_ai_report_to_student
                          ? copy.reportUnavailable
                          : copy.hiddenReport)}
                    </p>
                  </div>
                </div>

                {!!historyDetails.answers?.length && (
                  <div className="dashboard-card student-dashboard-card">
                    <h3>{copy.previousAnswers}</h3>
                    <div className="answers-list">
                      {historyDetails.answers.map((answer) => (
                        <div key={answer.id} className="answer-card">
                          <strong>{answer.question_text}</strong>
                          <p>
                            {answer.question_type === "essay"
                              ? answer.answer_text || copy.noEssayAnswer
                              : answer.selected_option_text || copy.noSelectedOption}
                          </p>
                          {(answer.sentiment_label || answer.detected_skills) && (
                            <div className="ai-meta">
                              <span>
                                {copy.sentiment}: {answer.sentiment_label || "-"}
                              </span>
                              <span>
                                {copy.level}: {answer.detected_skills || "-"}
                              </span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {!historyDetails.answers?.length && !historyDetails.submission?.show_answers_to_student && (
                  <div className="dashboard-card student-dashboard-card">
                    <h3>{copy.previousAnswers}</h3>
                    <div className="empty-panel compact-panel state-panel state-panel--empty">
                      <p>{copy.hiddenAnswers}</p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
}

export default StudentExam;
